function resetar() {
  var x1 = Math.floor(Math.random()* 2000 + 500);
  var counter = document.getElementById("n1");

  if (counter) {
    counter.textContent = x1;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', resetar);
} else {
  resetar();
}

(function () {
  function clampProgress(progress) {
    return Math.max(0, Math.min(1, progress));
  }

  function getFlickityControls(carousel) {
    return {
      previous: carousel.querySelector('.flickity-prev-next-button.previous'),
      next: carousel.querySelector('.flickity-prev-next-button.next')
    };
  }

  function updateProgress(carousel, progressBar, flickityControls) {
    if (!progressBar) {
      return;
    }

    if (flickityControls.previous && flickityControls.next) {
      var items = Array.prototype.slice.call(carousel.querySelectorAll('.product-item'));
      var selectedItems = items.filter(function (item) {
        return item.classList.contains('is-selected');
      });
      var lastSelected = selectedItems[selectedItems.length - 1];
      var lastSelectedIndex = lastSelected ? items.indexOf(lastSelected) + 1 : 0;
      var flickityProgress = items.length ? lastSelectedIndex / items.length : 0;

      progressBar.style.width = (clampProgress(flickityProgress) * 100) + '%';
      return;
    }

    var contentWidth = carousel.scrollWidth;
    var progress = contentWidth > carousel.clientWidth
      ? (carousel.scrollLeft + carousel.clientWidth) / contentWidth
      : 1;

    progressBar.style.width = (clampProgress(progress) * 100) + '%';
  }

  function prepareNativeCarousel(carousel) {
    var flickityControls = getFlickityControls(carousel);

    if (flickityControls.previous && flickityControls.next) {
      return false;
    }

    carousel.classList.add('product-list--native-scroll');
    return true;
  }

  function bindFeaturedCollection(section) {
    var carousel = section.querySelector('.product-list--peek');
    var controls = section.querySelector('[data-featured-collection-controls]');

    if (!carousel || !controls || controls.dataset.bound === 'true') {
      return;
    }

    var progressBar = controls.querySelector('.featured-collection__carousel-progress-bar');
    var previousButton = controls.querySelector('[data-featured-collection-action="previous"]');
    var nextButton = controls.querySelector('[data-featured-collection-action="next"]');

    if (!previousButton || !nextButton) {
      return;
    }

    var usesNativeScroll = prepareNativeCarousel(carousel);
    controls.dataset.bound = 'true';

    function updateControls() {
      var flickityControls = getFlickityControls(carousel);

      if (flickityControls.previous && flickityControls.next) {
        carousel.classList.remove('product-list--native-scroll');
        previousButton.disabled = flickityControls.previous.disabled;
        nextButton.disabled = flickityControls.next.disabled;
        updateProgress(carousel, progressBar, flickityControls);
        return;
      }

      var maxScrollLeft = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
      previousButton.disabled = maxScrollLeft <= 1 || carousel.scrollLeft <= 1;
      nextButton.disabled = maxScrollLeft <= 1 || carousel.scrollLeft >= maxScrollLeft - 1;
      updateProgress(carousel, progressBar, flickityControls);
    }

    function moveCarousel(direction) {
      var flickityControls = getFlickityControls(carousel);
      var flickityButton = direction < 0 ? flickityControls.previous : flickityControls.next;

      if (flickityButton) {
        if (!flickityButton.disabled) {
          flickityButton.click();
        }

        window.setTimeout(updateControls, 360);
        return;
      }

      var firstCard = carousel.querySelector('.product-item');
      var cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 0;
      var cardMargin = firstCard ? parseFloat(window.getComputedStyle(firstCard).marginRight) || 0 : 0;
      var distance = (cardWidth > 0 ? cardWidth + cardMargin : carousel.clientWidth) * direction;

      if (typeof carousel.scrollBy === 'function') {
        carousel.scrollBy({ left: distance, behavior: 'smooth' });
      } else {
        carousel.scrollLeft += distance;
      }

      window.setTimeout(updateControls, 360);
    }

    previousButton.addEventListener('click', function () {
      moveCarousel(-1);
    });

    nextButton.addEventListener('click', function () {
      moveCarousel(1);
    });

    if (usesNativeScroll) {
      carousel.addEventListener('scroll', updateControls, { passive: true });
    } else if (window.MutationObserver) {
      var observer = new MutationObserver(updateControls);
      observer.observe(carousel, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'disabled']
      });
    }

    window.addEventListener('resize', updateControls);

    window.setTimeout(function () {
      updateControls();
    }, 180);

    if (document.readyState !== 'complete') {
      window.addEventListener('load', updateControls, { once: true });
    }

    updateControls();
  }

  function bindAllFeaturedCollections() {
    document.querySelectorAll('[data-section-type="featured-collection"]').forEach(bindFeaturedCollection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAllFeaturedCollections);
  } else {
    bindAllFeaturedCollections();
  }

  document.addEventListener('shopify:section:load', bindAllFeaturedCollections);
})();

(function () {
  function variantCanBePurchased(variant) {
    if (!variant) {
      return false;
    }

    return Boolean(
      variant.available ||
      variant.inventory_policy === 'continue' ||
      Number(variant.inventory_quantity) > 0
    );
  }

  function updateProductAvailability(section, variant) {
    var addToCartButton = section.querySelector('.product-form__add-button');
    var availabilityMessage = section.querySelector('[data-product-availability]');

    if (!addToCartButton || !variant) {
      return;
    }

    if (variantCanBePurchased(variant)) {
      addToCartButton.removeAttribute('disabled');
      addToCartButton.classList.remove('button--disabled');
      addToCartButton.classList.add('button--primary');
      addToCartButton.setAttribute('data-action', 'add-to-cart');

      addToCartButton.textContent = window.languages && window.languages.productFormAddToCart
        ? window.languages.productFormAddToCart
        : 'Adicionar ao carrinho';

      if (availabilityMessage) {
        availabilityMessage.style.display = '';
      }
    } else {
      addToCartButton.setAttribute('disabled', 'disabled');
      addToCartButton.classList.add('button--disabled');
      addToCartButton.classList.remove('button--primary');
      addToCartButton.removeAttribute('data-action');

      addToCartButton.textContent = window.languages && window.languages.productFormSoldOut
        ? window.languages.productFormSoldOut
        : 'Esgotado';

      if (availabilityMessage) {
        availabilityMessage.style.display = 'none';
      }
    }

    var paymentButton = section.querySelector('.shopify-payment-button');
    if (paymentButton) {
      paymentButton.style.display = variantCanBePurchased(variant) ? 'block' : 'none';
    }
  }

  function bindProductAvailability(section) {
    if (!section || section.dataset.productAvailabilityBound === 'true') {
      return;
    }

    var productJson = section.querySelector('[data-product-json]');
    if (!productJson) {
      return;
    }

    var data;
    try {
      data = JSON.parse(productJson.textContent);
    } catch (error) {
      return;
    }

    var variants = data.product && data.product.variants ? data.product.variants : [];
    var initialVariant = variants.find(function (variant) {
      return String(variant.id) === String(data.selected_variant_id);
    });

    section.dataset.productAvailabilityBound = 'true';
    section.addEventListener('variant:changed', function (event) {
      updateProductAvailability(section, event.detail && event.detail.variant);
    });

    if (initialVariant) {
      updateProductAvailability(section, initialVariant);
    }
  }

  function bindAllProductAvailability() {
    document.querySelectorAll('[data-section-type="product"]').forEach(bindProductAvailability);
  }

  function bindCrossSell(section) {
    if (!section || section.dataset.crossSellBound === 'true') {
      return;
    }

    var carousel = section.querySelector('.product-cross-sell__list');
    var previousButton = section.querySelector('[data-cross-sell-action="previous"]');
    var nextButton = section.querySelector('[data-cross-sell-action="next"]');

    if (!carousel || !previousButton || !nextButton) {
      return;
    }

    var flickity = null;

    if (window.Flickity) {
      flickity = typeof window.Flickity.data === 'function' ? window.Flickity.data(carousel) : null;

      if (!flickity) {
        flickity = new window.Flickity(carousel, {
          watchCSS: false,
          pageDots: false,
          prevNextButtons: false,
          contain: true,
          groupCells: true,
          cellAlign: 'left',
          draggable: true
        });
      }
    }

    function updateControls() {
      if (flickity) {
        var lastSlideIndex = Math.max(0, flickity.slides.length - 1);
        previousButton.disabled = flickity.selectedIndex <= 0;
        nextButton.disabled = flickity.selectedIndex >= lastSlideIndex;
        return;
      }

      var maxScrollLeft = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
      previousButton.disabled = maxScrollLeft <= 1 || carousel.scrollLeft <= 1;
      nextButton.disabled = maxScrollLeft <= 1 || carousel.scrollLeft >= maxScrollLeft - 1;
    }

    function moveCarousel(direction) {
      if (flickity) {
        if (direction < 0) {
          flickity.previous();
        } else {
          flickity.next();
        }

        return;
      }

      var distance = Math.max(carousel.clientWidth * 0.8, 280) * direction;

      if (typeof carousel.scrollBy === 'function') {
        carousel.scrollBy({ left: distance, behavior: 'smooth' });
      } else {
        carousel.scrollLeft += distance;
      }
    }

    previousButton.addEventListener('click', function () {
      moveCarousel(-1);
    });
    nextButton.addEventListener('click', function () {
      moveCarousel(1);
    });

    if (flickity) {
      flickity.on('select', updateControls);
      flickity.on('resize', updateControls);
    } else {
      carousel.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls);
    }

    section.dataset.crossSellBound = 'true';
    updateControls();
  }

  function loadCrossSellRecommendations(section) {
    var recommendationsUrl = section.getAttribute('data-recommendations-url');

    if (!recommendationsUrl || section.dataset.crossSellRecommendationsLoaded === 'true') {
      return Promise.resolve();
    }

    section.dataset.crossSellRecommendationsLoaded = 'true';
    section.setAttribute('aria-busy', 'true');

    return fetch(recommendationsUrl, {
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to load complementary products');
      }

      return response.text();
    }).then(function (html) {
      var container = document.createElement('div');
      container.innerHTML = html;

      var replacement = container.querySelector('[data-section-type="product-cross-sell"]');

      if (!replacement) {
        section.hidden = true;
        return;
      }

      section.innerHTML = replacement.innerHTML;
      section.hidden = replacement.hidden;
    }).catch(function () {
      section.hidden = false;
    }).then(function () {
      section.removeAttribute('aria-busy');
    });
  }

  function bindAllCrossSells() {
    document.querySelectorAll('[data-section-type="product-cross-sell"]').forEach(function (section) {
      loadCrossSellRecommendations(section).then(function () {
        bindCrossSell(section);
      });
    });
  }

  function bindProductEnhancements() {
    bindAllProductAvailability();
    bindAllCrossSells();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.setTimeout(bindProductEnhancements, 0);
    });
  } else {
    window.setTimeout(bindProductEnhancements, 0);
  }

  document.addEventListener('shopify:section:load', bindProductEnhancements);
})();

(function () {
  function parseDisplayedMoney(value) {
    var cleaned = String(value || '').replace(/[^0-9,.-]/g, '');
    var isNegative = cleaned.indexOf('-') !== -1;
    var unsigned = cleaned.replace(/-/g, '');
    var lastComma = unsigned.lastIndexOf(',');
    var lastPeriod = unsigned.lastIndexOf('.');
    var separatorIndex = Math.max(lastComma, lastPeriod);
    var decimalDigits = separatorIndex === -1 ? 0 : unsigned.length - separatorIndex - 1;
    var normalized;

    if (separatorIndex !== -1 && decimalDigits > 0 && decimalDigits <= 2) {
      normalized = unsigned.slice(0, separatorIndex).replace(/[^0-9]/g, '') + '.' + unsigned.slice(separatorIndex + 1).replace(/[^0-9]/g, '');
    } else {
      normalized = unsigned.replace(/[^0-9]/g, '');
    }

    if (!normalized) {
      return NaN;
    }

    var amount = Number(normalized);
    return Math.round(amount * 100) * (isNegative ? -1 : 1);
  }

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    var amount = Number(cents) / 100;

    if (!Number.isFinite(amount)) {
      return '';
    }

    var fixed = amount.toFixed(precision).split('.');
    var integer = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return precision === 0 ? integer : integer + decimal + fixed[1];
  }

  function formatShopifyMoney(cents, format) {
    var moneyFormat = format || (window.theme && window.theme.moneyFormat) || '{{amount}}';
    var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);

    if (!match) {
      return formatWithDelimiters(cents, 2, '.', ',');
    }

    var formattedAmount;

    switch (match[1]) {
      case 'amount_no_decimals':
        formattedAmount = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        formattedAmount = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formattedAmount = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        formattedAmount = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        formattedAmount = formatWithDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_space_separator':
        formattedAmount = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        formattedAmount = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount':
      default:
        formattedAmount = formatWithDelimiters(cents, 2, ',', '.');
        break;
    }

    var formatted = moneyFormat.replace(match[0], formattedAmount);
    var parser = document.createElement('div');
    parser.innerHTML = formatted;
    return parser.textContent || parser.innerText || formattedAmount;
  }

  function resetShippingEstimate(section) {
    var summary = section.querySelector('[data-cart-shipping-summary]');
    var originalTotal = section.querySelector('[data-cart-original-total]');
    var estimatedTotal = section.querySelector('[data-cart-estimated-total]');
    var checkoutNote = section.querySelector('.shipping-estimator__checkout-note');

    if (summary) {
      summary.hidden = true;
    }

    if (originalTotal) {
      originalTotal.hidden = false;
    }

    if (estimatedTotal) {
      estimatedTotal.hidden = true;
      estimatedTotal.textContent = '';
    }

    if (checkoutNote) {
      checkoutNote.hidden = true;
    }

    delete section.dataset.shippingRateSelected;
  }

  function selectShippingEstimate(section, input) {
    var recap = section.querySelector('.cart-recap');
    var summary = section.querySelector('[data-cart-shipping-summary]');
    var shippingPrice = section.querySelector('[data-cart-shipping-price]');
    var originalTotal = section.querySelector('[data-cart-original-total]');
    var estimatedTotal = section.querySelector('[data-cart-estimated-total]');
    var checkoutNote = section.querySelector('.shipping-estimator__checkout-note');

    if (!recap || !summary || !shippingPrice || !originalTotal || !estimatedTotal) {
      return;
    }

    var baseTotal = Number(recap.dataset.cartTotalCents);
    var shippingTotal = Number(input.value);

    if (!Number.isFinite(baseTotal) || !Number.isFinite(shippingTotal)) {
      return;
    }

    shippingPrice.textContent = input.dataset.displayPrice;
    summary.hidden = false;
    summary.setAttribute('aria-live', 'polite');
    originalTotal.hidden = true;
    estimatedTotal.hidden = false;
    estimatedTotal.textContent = formatShopifyMoney(baseTotal + shippingTotal, recap.dataset.moneyFormat);

    if (checkoutNote) {
      checkoutNote.hidden = false;
    }

    section.dataset.shippingRateSelected = 'true';
  }

  function enhanceShippingResults(section, results) {
    var list = results.querySelector('ul');

    if (!list) {
      resetShippingEstimate(section);
      return;
    }

    if (list.dataset.shippingOptionsEnhanced === 'true') {
      return;
    }

    var items = Array.prototype.slice.call(list.children).filter(function (item) {
      return item.tagName === 'LI';
    });
    var rates = items.map(function (item) {
      var text = item.textContent.trim();
      var separatorIndex = text.lastIndexOf(':');

      if (separatorIndex <= 0) {
        return null;
      }

      var displayPrice = text.slice(separatorIndex + 1).trim();
      var cents = parseDisplayedMoney(displayPrice);

      if (!Number.isFinite(cents)) {
        return null;
      }

      return {
        name: text.slice(0, separatorIndex).trim(),
        displayPrice: displayPrice,
        cents: cents
      };
    });

    if (!rates.length || rates.some(function (rate) { return rate === null; })) {
      resetShippingEstimate(section);
      return;
    }

    list.dataset.shippingOptionsEnhanced = 'true';
    list.classList.add('shipping-estimator__rate-list');

    items.forEach(function (item, index) {
      var rate = rates[index];
      var inputId = 'estimated-shipping-rate-' + section.dataset.sectionId + '-' + index;
      var label = document.createElement('label');
      var input = document.createElement('input');
      var marker = document.createElement('span');
      var name = document.createElement('span');
      var price = document.createElement('span');

      input.type = 'radio';
      input.name = 'estimated-shipping-rate';
      input.id = inputId;
      input.value = String(rate.cents);
      input.dataset.displayPrice = rate.displayPrice;
      input.checked = index === 0;

      label.className = 'shipping-estimator__rate-option';
      label.htmlFor = inputId;
      marker.className = 'shipping-estimator__rate-marker';
      name.className = 'shipping-estimator__rate-name';
      name.textContent = rate.name;
      price.className = 'shipping-estimator__rate-price';
      price.textContent = rate.displayPrice;

      label.appendChild(input);
      label.appendChild(marker);
      label.appendChild(name);
      label.appendChild(price);
      item.textContent = '';
      item.appendChild(label);
    });

    list.addEventListener('change', function (event) {
      if (event.target.matches('input[name="estimated-shipping-rate"]')) {
        selectShippingEstimate(section, event.target);
      }
    });

    selectShippingEstimate(section, list.querySelector('input[name="estimated-shipping-rate"]:checked'));
  }

  function bindCartShippingEstimate(section) {
    if (!section || section.dataset.shippingEstimateBound === 'true') {
      return;
    }

    var results = section.querySelector('.shipping-estimator__results');

    if (!results) {
      return;
    }

    var observer = new MutationObserver(function () {
      window.requestAnimationFrame(function () {
        enhanceShippingResults(section, results);
      });
    });

    observer.observe(results, { childList: true, subtree: true });
    section.dataset.shippingEstimateBound = 'true';
    enhanceShippingResults(section, results);
  }

  function bindAllCartShippingEstimates() {
    document.querySelectorAll('[data-section-type="cart"]').forEach(bindCartShippingEstimate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAllCartShippingEstimates);
  } else {
    bindAllCartShippingEstimates();
  }

  document.addEventListener('shopify:section:load', bindAllCartShippingEstimates);
})();
